import React from 'react';
import PropTypes from 'prop-types';
import {Twemoji} from '../../common';

const GiftLine = (props) => {
  const {count, emoji} = props;

  return (
    <div className="gifts-line">
      <Twemoji className="gifts-line__img" emoji={emoji}/>
      <span className="gifts-line__count">{count}</span>
    </div>
  );
};

GiftLine.propTypes = {
  count: PropTypes.number.isRequired,
  emoji: PropTypes.string.isRequired,
};

export default GiftLine;
